export default "__VITE_ASSET__CWB7DXhn__"